















import { Component, Vue } from 'vue-property-decorator';
import FormHeader from '@/app/common/component/FormHeader.vue';
import HeaderImg from '@/app/common/component/HeaderImg.vue';
import RemindPasswordForm from '@/app/auth/remindPassword/RemindPasswordForm.vue';
import AuthService from '@/app/common/service/AuthService';
import NotificationService from '@/app/common/service/NotificationService';
import IRemindPasswordForm from '@/app/auth/remindPassword/IRemindPasswordForm';

@Component({
  name: 'RemindPasswordContainer',
  components: { FormHeader, RemindPasswordForm, HeaderImg },
})
export default class RemindPasswordContainer extends Vue {
  get logoUrl(): string {
    return this.$store.getters.logoUrl;
  }

  public async onRemindPassword(api: IRemindPasswordForm): Promise<void> {
    try {
      await AuthService.remindPassword(api);
      NotificationService.success('Email z przypomnieniem został wysłany');
    } catch (e) {
      NotificationService.error(e);
    }
  }
}
